<template>
  <div>
    <div class="header" v-for="(item, index) in imgList" :key="index">
      <img
        class="img"
        :class="[index > 0 ? 'imgTwo' : '', index == 0 ? 'imgTree' : '']"
        :src="item.img"
        alt=""
      />
    </div>
    <div class="hegin"></div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      imgList: [
        {
          img: require("../assets/shareholderCard/shareholderCard1.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard2.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard3.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard4.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard5.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard6.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard7.png"),
        },
        {
          img: require("../assets/shareholderCard/shareholderCard8.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
}
.img {
  max-width: 100%;
}
.imgTwo {
  margin-top: -3px;
}
.hegin {
  height: 1.875rem /* 30/16 */;
}
.imgTree {
  margin-bottom: 0.9375rem /* 15/16 */;
}
</style>
